import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import posthog from "posthog-js";
import { ENVIRONMENT, POSTHOG_API_KEY } from "./env";

const SERVICE_NAME = "social-media-counts-installable";

// "production" covers both "production" and "prod"; every other value
// (staging, dev, empty) is reported as "staging".
const NORMALIZED_ENVIRONMENT =
  ENVIRONMENT === "production" || ENVIRONMENT === "prod"
    ? "production"
    : "staging";

if (POSTHOG_API_KEY) {
  posthog.init(POSTHOG_API_KEY, {
    api_host: "https://p.vestaboard.com",
    autocapture: false,
    capture_pageview: false,
    capture_exceptions: true,
    loaded: (client) =>
      client.register({
        service: SERVICE_NAME,
        environment: NORMALIZED_ENVIRONMENT,
      }),
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
